import {
    UntypedFormControl,
    ValidatorFn,
    Validators,
    AbstractControl,
} from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ValidationMessage } from './validator.model';

export class FormControl extends UntypedFormControl {
    constructor(public name: string) {
        super();

        this.validationMessages$.subscribe(
            (vms) => (this.validationKeys = vms.map((vm) => vm.key))
        );
        this.validators$.subscribe((validators) =>
            this.setValidators(validators)
        );

        this.serverValidationMessage = {
            key: 'serverError',
            message: null,
        };

        this.addValidationMessage(this.serverValidationMessage);
    }
    validationMessages$ = new BehaviorSubject<ValidationMessage[]>([]);
    validators$ = new BehaviorSubject<ValidatorFn[]>([]);

    validationKeys: string[] = [];

    isRequired: boolean;

    serverValidationMessage: ValidationMessage;

    minLengthValue?: number;

    maxLengthValue?: number;

    required(message: string) {
        this.addValidator(Validators.required);
        this.addValidationMessage({ key: 'required', message: message });
        this.isRequired = true;
        return this;
    }

    requiredTrue(message: string) {
        this.addValidator(Validators.requiredTrue);
        this.addValidationMessage({ key: 'requiredTrue', message: message });
        return this;
    }

    pattern(regexp: string | RegExp, message: string) {
        this.addValidator(Validators.pattern(regexp));
        this.addValidationMessage({ key: 'pattern', message: message });
        return this;
    }

    minLength(length: number) {
        this.minLengthValue = length;
        this.addValidator(Validators.minLength(this.minLengthValue));
        this.addValidationMessage({key: 'minlength', message: 'test'})
        return this;
    }

    maxLength(length: number) {
        this.maxLengthValue = length;
        this.addValidator(Validators.maxLength(this.minLengthValue));
        return this;
    }

    getErrorMessage(key: string) {
        return this.validationMessages$.value.find((vm) => vm.key === key)
            .message;
    }

    addServerError(message: string) {
        this.serverValidationMessage.message = message;
        this.setErrors({
            serverError: true,
        });
        this.markAsTouched();
    }

    cleanServerError() {
        this.serverValidationMessage.message = null;
        this.setErrors({
            serverError: null,
        });
        this.updateValueAndValidity();
    }

    addValidator(validator: ValidatorFn) {
        const clone = this.validators$.value.slice();
        clone.push(validator);
        this.validators$.next(clone);
    }

    addValidationMessage(message: ValidationMessage) {
        const clone = this.validationMessages$.value.slice();
        clone.push(message);
        this.validationMessages$.next(clone);
    }
}
